// extracted by mini-css-extract-plugin
export default {"placeholder":"outrights-widget-placeholder_placeholder__ce4g6"};